import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from '../hooks/useTranslation';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRole?: 'client' | 'provider' | 'admin';
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const { t } = useTranslation();

  // Show loading while checking authentication
  if (isLoading) {
    return <div>{t('loading')}</div>;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check role permission if required
  if (requiredRole && user?.userType !== requiredRole) {
    // Redirect to appropriate dashboard based on user's actual role
    switch (user?.userType) {
      case 'client':
        return <Navigate to="/client" replace />;
      case 'provider':
        return <Navigate to="/provider" replace />;
      case 'admin':
        return <Navigate to="/admin" replace />;
      default:
        return <Navigate to="/login" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute; 